let pos_settings_UserItem = require("../../templates/pos/settings/UserItem.handlebars");
let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import POS from "../../POS.js";

let UserSettingModel = require("../../model/settings/UserSettingModel.js");
import i18n from "../../utils/i18n";

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .user": "selectUser",
            "click .save": "userExists",
            "click .delete": "deleteUser",
            "click .createNew": "createNewUser",
            "click .bind-weixin": "bindWeixin",
            "click .bind-wxr": "bindWXR",
            "click .navbar-btn": "listUser",
            'click .radio-btn': '_clickRadio',
            'click .check-box': '_clickCheckbox',
            'click .disbind-weixin': "disBindWeixinLogin"
        },

        initialize: function () {
            if (!this.model) {
                this.model = new UserSettingModel({currentUser: POS.get('username')});
            }
        },

        render: function (evt) {
            this.$('.alert').addClass('hidden');
            this.$("form").removeClass("hidden");
            if (this.model.get('currentUser')) {
                this.renderEditUser(evt);
                this.$('.bindWeinxin').show();
                this.$('.bindWXR').show();
            } else {
                this.renderCreateNewUser();
                this.$('.bindWeinxin').hide();
                this.$('.bindWXR').hide();
            }
            return this;
        },

        _clickRadio: function (event) {
            var _this = $(event.currentTarget),
                block = _this.closest(".form-group");
            block.find('input:radio').attr('checked', false);
            block.find(".radio-btn").removeClass('checkedRadio');
            _this.addClass('checkedRadio');
            _this.find('input:radio').attr('checked', true);
        },

        _clickCheckbox: function (event) {
            var _this = $(event.currentTarget),
                checkbox = _this.find('input:checkbox');
            checkbox.attr('checked', !checkbox.attr('checked'));
            _this.toggleClass('checkedBox');
        },


        renderEditUser: function (evt) {
            var user = this.$('.userList .user[data-username="' + this.model.get('currentUser') + '"]'),
                roles = user.attr('data-roles');
            this.model.set('currentUserId', user.data('id'));
            this.$('.user, .createNew').removeClass('selected');
            this.$('.username.form-group').removeClass('hidden');
            user.addClass('selected');
            this.$('.phone.form-group .info').addClass('hidden');
            this.$('#inputName').val(user.attr('data-fullname'));
            this.$('#inputUsername').val(user.attr('data-username'));
            this.$('#inputEmail').val(user.attr('data-email'));
            this.$('#inputPhone').val(user.attr('data-phone'));
            this.$('#staffNo').val(user.attr('data-staffno'));
            if (user.data('bindweixinlogin')) {
                this.$('.bind-weixin-login').addClass('hidden');
                this.$('.dis-bind-weixin-login').removeClass('hidden');
            } else {
                this.$('.bind-weixin-login').removeClass('hidden');
                this.$('.dis-bind-weixin-login').addClass('hidden');
            }
            if (roles) {
                this.$('.courierCheck').attr('checked', roles.indexOf('COURIER') >= 0);
                this.$('.courierCheck').closest(".check-box").toggleClass("checkedBox", roles.indexOf('COURIER') >= 0);
                this.$('.staffCheck').attr('checked', roles.indexOf('STAFF') >= 0);
                this.$('.staffCheck').closest(".check-box").toggleClass("checkedBox", roles.indexOf('STAFF') >= 0);
                this.$('.adminCheck').attr('checked', roles.indexOf('ADMIN') >= 0);
                this.$('.adminCheck').closest(".check-box").toggleClass("checkedBox", roles.indexOf('ADMIN') >= 0);
            }

            console.log('edit user');

            if (POS.get('username') != user.attr('data-username')) {
                this.$('.oldPwd.form-group').addClass('hidden');

                if (!POS.getUser().isAdmin && POS.getRestaurant().get('staffCashier')) {
                    this.$('.delete').addClass('hidden');
                    this.$('.pwd, .cpwd').hide();
                } else {
                    this.$('.del').removeClass('hidden');
                    this.$('.delete').removeClass('hidden');
                    this.$('.pwd, .cpwd').show();
                }

            } else {
                this.$('.pwd, .cpwd').show();
                this.$('.oldPwd.form-group').removeClass('hidden');
                this.$('.delete').addClass('hidden');
                this.$('.bindWeinxin .del').removeClass('hidden');
            }
        },

        renderCreateNewUser: function () {
            this.$('fieldset').attr('disabled', null);
            this.$('.username.form-group, .oldPwdGroup').addClass('hidden');
            this.$('.email.form-group .info').removeClass('hidden');
            this.$('.phone.form-group .info').removeClass('hidden');
            this.$('.createNew').addClass('selected');
            this.$('.user').removeClass('selected');
            this.$('#inputName, #inputEmail, #inputPhone, #staffNo').val("");
            this.$('.staffCheck').attr('checked', true);
            this.$('.staffCheck').closest(".check-box").addClass("checkedBox");
            this.$('.adminCheck').attr('checked', false);
            this.$('.adminCheck').closest(".check-box").removeClass("checkedBox");
            this.$('.courierCheck').attr('checked', false);
            this.$('.courierCheck').closest(".check-box").removeClass("checkedBox");
            this.$('.pwd, .cpwd').show();
            this.$('.del').addClass('hidden');
            this.$("#inputPassword").val("");
        },

        selectUser: function (evt) {
            var user = $(evt.currentTarget);
            this.model.set({
                currentUser: user.attr('data-username'),
                currentUserId: user.data('id'),
                email: user.attr('data-email'),
                fullname: user.attr('data-fullname'),
                phone: user.attr('data-phone')
            });
            console.log("this.model:", this.model);
            var modal = this.$('.userCreateModal');
            modal.find('.modal-title').text(i18n.msg("pos.setting.user.edit"));
            if (modal.find('.save').hasClass("saveCreate-btn")) {
                modal.find('.save').removeClass('saveCreate-btn');
            }
            if (!modal.find('.save').hasClass("saveEdit-btn")) {
                modal.find('.save').addClass('saveEdit-btn');
            }

            modal.find('.form-group.name').removeClass("has-error");
            modal.find('.form-group.name .help-block').addClass("hidden");

            modal.find('.form-group.email').removeClass("has-error");
            modal.find('.form-group.email .help-block-error').addClass("hidden");

            modal.find('.form-group.pwd').removeClass("has-error");
            modal.find('.form-group.pwd .help-block').addClass("hidden");

            modal.find('.form-group.staffNo').removeClass("has-error");
            modal.find('.form-group.staffNo .help-block').addClass("hidden");

            modal.find('.form-group.phone').removeClass("has-error");
            modal.find('.form-group.phone .help-block').addClass("hidden");

            modal.modal('show');
            this.render(evt);
        },

        createNewUser: function () {
            this.model.set({currentUser: null, currentUserId: null});
            var modal = this.$('.userCreateModal');
            modal.find('.modal-title').text(i18n.msg("pos.setting.user.new"));
            if (modal.find('.save').hasClass("saveEdit-btn")) {
                modal.find('.save').removeClass('saveEdit-btn');
            }
            if (!modal.find('.save').hasClass("saveCreate-btn")) {
                modal.find('.save').addClass('saveCreate-btn');
            }
            this.$('.modal.userCreateModal').modal('show');

            modal.find('.form-group.name').removeClass("has-error");
            modal.find('.form-group.name .help-block').addClass("hidden");

            modal.find('.form-group.email').removeClass("has-error");
            modal.find('.form-group.email .help-block-error').addClass("hidden");

            modal.find('.form-group.pwd').removeClass("has-error");
            modal.find('.form-group.pwd .help-block').addClass("hidden");

            modal.find('.form-group.staffNo').removeClass("has-error");
            modal.find('.form-group.staffNo .help-block').addClass("hidden");

            modal.find('.form-group.phone').removeClass("has-error");
            modal.find('.form-group.phone .help-block').addClass("hidden");
            this.render();
        },

        userExists: function () {
            this.$('.form-group').removeClass('has-error').find('.help-block.error').text("");

            if (this.model.get('currentUser')) {
                this.saveUser();
                return false;
            }

            var params = {username: this.$('#inputPhone').val(), phone: this.$('#inputPhone').val()},
                result = $.post('/staff/exist/' + POS.get('rId'), params), self = this;

            if (this.$('#inputName').val().trim() == "") {
                this.$('.form-group.name .help-block').removeClass('hidden');
                this.$('.form-group.name').addClass('has-error').find('.help-block').text(i18n.msg('pos.validation.notEmpty'));
                return false;
            } else {
                this.$('.form-group.name .help-block').addClass('hidden');
            }

            if (this.$('#inputPhone').val().trim() == "") {
                this.$('.form-group.phone .help-block-error').removeClass('hidden');
                this.$('.form-group.phone').addClass('has-error').find('.help-block-error').text(i18n.msg('pos.validation.notEmpty'));
                return false;
            } else {
                this.$('.form-group.phone .help-block-error').addClass('hidden');
            }
            POS.showLoading(true);
            result.done(function (res) {
                console.log(res);
                if (res.addUser && confirm(res.errors)) {
                    console.log(res.userId);
                    self.saveUser(res.userId);

                } else {
                    if (res.hasStaffPhone) {
                        alert(res.errors);
                        return;
                    }

                    self.saveUser();
                }
            });

            result.fail(function (res) {
                alert(res);
            });
            result.always(function (response) {
                POS.showLoading(false);
            });

            return false;
        },

        updatePassword: function () {
            console.log('update password');

            var pwdParams = {
                oldPassword: this.$('#oldPassword').val().trim(),
                password: this.$('#inputPassword').val().trim()
            }, self = this;

            if (pwdParams.oldPassword && pwdParams.password) {
                if (confirm(i18n.msg('pos.setting.user.updatePwd'))) {
                    return $.post('/user/updatePassword', pwdParams);

                } else {
                    return null;
                }

            } else {
                return {updateUser: true};
            }

            return null;
        },

        saveUser: function (userId) {
            console.log('update user');
            this.$('.has-error').removeClass('has-error');

            var self = this, pwdResult = null;

            if (POS.get('username') == this.model.get('currentUser')) {
                pwdResult = this.updatePassword();
                POS.showLoading(true);
                if (pwdResult) {
                    if (pwdResult.updateUser) {
                        this.saveUserInfo(userId);
                        return false;
                    }
                    pwdResult.done(function (res) {
                        if (!res.success) {
                            if (res.errors.pwr) {
                                self.$('.oldPwd').addClass('has-error');
                                self.$('.oldPwd .help-block').text(res.errors.pwr);

                            } else {
                                alert(res.errors);
                            }
                        } else {
                            self.saveUserInfo(userId);
                        }
                    });

                    pwdResult.fail(function (res) {
                        alert("failed to update password");
                    });
                    pwdResult.always(function (response) {
                        POS.showLoading(false);
                    });
                }

            } else {
                this.saveUserInfo(userId);
            }

            return false;
        },

        /**
         * Creaet user or update info apart from password
         */
        saveUserInfo: function (userId) {
            this.$("input[name='username']").val(this.$('#inputPhone').val());
            var params = this.$('form').serialize(),
                url = this.model.get('currentUser') ? "/staff/update/" + this.model.get('currentUserId') :
                    '/staff/save/' + POS.get('rId') + (userId ? '?userId=' + userId : ''),
                self = this,
                result = null;
            if (this.$("input.staffCheck").attr("checked")) {
                params += "&roles=ROLE_RESTAURANT_STAFF";
            }
            if (this.$("input.adminCheck").attr("checked")) {
                params += "&roles=ROLE_RESTAURANT_ADMIN";
            }
            if (this.$("input.courierCheck").attr("checked")) {
                params += "&roles=ROLE_RESTAURANT_COURIER";
            }
            params += "&roles=ROLE_USER";
            console.log("url:", url);
            if (url.indexOf('save') > 0) {
                if (!userId && this.$('#inputPassword').val().trim() == 0) {
                    this.$('.form-group.pwd').addClass('has-error').find('.help-block').text(i18n.msg('pos.validation.notEmpty'));
                    return false;
                }
            }
            result = $.post(url, params);
            POS.showLoading(true);
            result.done(function (res) {
                console.log('add user result');

                if (res.success) {
                    self.trigger('needRefresh');
                    console.log(res);

                    if (!self.model.get('currentUser') && res.staff) {
                        console.log("res.staff=", res.staff);
                        res.staff.roles = res.roles;
                        self.$('.userList tbody').append($(pos_settings_UserItem(res.staff)));
                        self.model.set('currentUser', res.staff);
                        self.model.set('currentUserId', res.staff.id);
                        self.$('.userList .user[data-id=' + res.staff.id + ']').addClass("selected");
                        if (POS.getUser().isAdmin) {
                            self.$(".del").removeClass("hidden");
                            self.$(".delete").removeClass("hidden");
                        }
                    }

                    var user = $('.userList .user.selected');
                    var rolesStr = "";
                    _.each(res.roles.split(','), function (role) {
                        if (role) {
                            rolesStr = rolesStr + (role == 'ROLE_RESTAURANT_STAFF' ? i18n.msg("pos.role.staff") + ' ' : i18n.msg("pos.role.admin") + ' ');
                        }
                    });
                    user.attr("data-roles", res.roles);
                    user.find('.roles-td').text(rolesStr);
                    self.$('.bind-weixin').show();
                    self.$('.userCreateModal').modal('hide');
                    self.listUser();
                } else {
                    self.showError(res.errors);
                }
            });

            result.fail(function (res) {
                console.log("failed", res);
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        deleteUser: function () {
            var selectedUser = this.$('.user.selected'), staffId = selectedUser.data('id'),
                result = null, self = this;
            if (this.$('.userList .user').size() == 1 && parseInt(this.$('.userList-header .billItemCount').text()) == 1) {
                alert(i18n.msg('pos.setting.user.deleteOnlyUser'));
                return false;
            }

            console.log("deleting staff id: ", staffId);

            if (!window.confirm(i18n.msg('pos.settings.confirmDelete', [selectedUser.data('fullname')]))) {
                return false;
            }

            result = $.post('/staff/delete', {staffId: staffId});
            POS.showLoading(true);
            result.done(function (res) {
                if (res.success) {
                    selectedUser.remove();
                    self.$('.alert').removeClass('hidden').text(i18n.msg('pos.setting.user.deleted'));
                    self.$("form").addClass("hidden");
                    self.$('.modal').modal('hide');
                    self.listUser();
                } else {
                    alert(i18n.msg('pos.setting.user.delete.failed'));
                }
            });

            result.fail(function (res) {
                alert(i18n.msg('pos.setting.user.delete.failed'));
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
            return false;
        },

        showError: function (errors) {
            if (errors.email) {
                this.$('.form-group.email').addClass('has-error').find('.help-block.error').removeClass('hidden').text(errors.email);
            }

            if (errors.phone) {
                this.$('.form-group.phone').addClass('has-error').find('.help-block').text(errors.phone);
            }

            if (errors.staffNo) {
                this.$('.form-group.staffNo').addClass('has-error').find('.help-block').removeClass('hidden').text(errors.staffNo);
            }
        },

        listUser: function (e) {
            var offset = 0, self = this;
            if (e) {
                offset = $(e.currentTarget).data("offset");
            }
            var rest = POS.getRestaurant(), result = $.post('/user/listUser', {
                    offset: offset
                }
            );
            POS.showLoading(true);
            result.done(function (res) {
                self.$('.main .userList').empty().append(res);
            });
            result.always(function (response) {
                POS.showLoading(false);
            });
        },

        bindWeixin: function () {
            this.$('.bind-weixin').prop("disabled", true);
            var selectedUser = this.$('.user.selected'), staffId = selectedUser.data('id');
            var self = this;
            POS.showLoading(true);
            $.post('/staff/staffBindingForWebLoginQrCode', {staffId: staffId}).always(function (data) {
                POS.showLoading(false);
                self.$('.bind-weixin').prop("disabled", false);
                if (data.status == 200) {
                    self.$('.modal img').attr('src', 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + data.ticket);
                    var modal = self.$('.modal.bindWeixin');
                    modal.modal('show');
                } else {
                    alert(i18n.msg('pos.setting.user.bind.weixin.msg.generate.code.failed'));
                }
            });

        },

        bindWXR: function () {
            this.$('.bind-wxr').prop("disabled", true);
            var selectedUser = this.$('.user.selected'), staffId = selectedUser.data('id');
            var self = this;
            POS.showLoading(true);
            $.post('/staff/staffBindingForWebLoginQrCode', {staffId: staffId, type: 'wxr'}).always(function (data) {
                POS.showLoading(false);
                self.$('.bind-wxr').prop("disabled", false);
                if (data.status == 200) {
                    self.$('.modal img').attr('src', 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + data.ticket);
                    var modal = self.$('.modal.bind-WXR');
                    modal.modal('show');
                } else {
                    alert(i18n.msg('pos.setting.user.bind.weixin.msg.generate.code.failed'));
                }
            });
        },


        disBindWeixinLogin: function () {
            this.$('.disbind-weixin').prop("disabled", true);
            var selectedUser = this.$('.user.selected'), staffId = selectedUser.data('id');
            var self = this;
            POS.showLoading(true);
            $.post('/staff/staffDisBindingForWebLogin', {staffId: staffId}).always(function (data) {
                POS.showLoading(false);
                self.$('.disbind-weixin').prop("disabled", false);
                if (data.status == 200) {
                    self.$('.dis-bind-weixin-login').addClass('hidden');
                    self.$('.bind-weixin-login').removeClass('hidden');
                } else {
                    alert(i18n.msg('pos.setting.user.disbind.weixin.msg.generate.code.failed'));
                }
            });
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/settings/UserSettingView.js